import Vue from 'vue';
import { VueMasonryPlugin } from 'vue-masonry';

export default () => {
  Vue.use(VueMasonryPlugin);
};
